var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookIconWhite = function SvgFacebookIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "4 4 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.418 0-8 3.595-8 8.03a8.027 8.027 0 0 0 6.067 7.792v-5.339h-1.65V12.03h1.65v-1.057c0-2.733 1.233-4 3.906-4 .507 0 1.381.1 1.74.2v2.224c-.19-.02-.518-.03-.925-.03-1.312 0-1.819.499-1.819 1.796v.867h2.614l-.45 2.454H12.97V20C16.931 19.52 20 16.135 20 12.03 20 7.594 16.418 4 12 4Z",
    fill: "#fff"
  })));
};
export default SvgFacebookIconWhite;